<template>
  <div>
    <p
      v-if="canUploadVideos && temporaryBucket"
      class="text-sm mb-4 text-grey-600 mx-auto"
      :style="tabWidth"
    >
      {{ $t('frontend_groovevideo_videos_fileupload_upload') }}
    </p>
    <div v-if="canUploadVideos">
      <div class="upload videouploadLoader">
        <vue-dropzone
          id="customdropzone"
          ref="myVueDropzone"
          v-if="temporaryBucket"
          :options="dropzoneOptions"
          :use-custom-slot="true"
          :awss3="awss3"
          @[useGrooveStorage?`vdropzone-success`:null]="uploadSuccess"
          @vdropzone-s3-upload-error="uploadError"
          @[!useGrooveStorage?`vdropzone-s3-upload-success`:null]="
            s3UploadSuccess
          "
          @vdropzone-upload-progress="uploadProgress"
          @vdropzone-total-upload-progress="totalProgress"
          @vdropzone-file-added="fileAdded"
        >
          <div class="dropzone-custom-content">
            <div
              class="
                border-dashed
                rounded-lg
                bgcolor
                border-grey-100 border
                flex flex-col
                h-40
                justify-center
                items-center
                px-4
              "
            >
              <div class="text-xs subtitle mb-3">
                {{ $t('frontend_groovevideo_videos_fileupload_drag_drop') }}
                <br />
                {{ $t('frontend_groovevideo_videos_fileupload_or') }}
              </div>
              <div
                class="
                  w-full
                  flex flex-row flex-nowrap
                  items-center
                  justify-center
                "
              >
                <gd-button primary class="px-4 w-auto mr-2">
                  {{ $t('frontend_groovevideo_videos_selectfile') }}
                </gd-button>
              </div>
              <div
                class="
                  p-2
                  flex flex-row flex-nowrap
                  items-center
                  justify-center
                  text-xs
                  subtitle
                  text-pink
                "
              >
                {{ $t('frontend_groovevideo_video_size_limit') }}
              </div>
            </div>
          </div>
        </vue-dropzone>

        <div v-if="video.video_source" class="flex justify-center mt-6">
          <gd-button @click="sendBack">
            {{ $t('frontend_cancel') }}
          </gd-button>
        </div>
        <div
          v-else-if="!temporaryBucket"
          class="text-sm font-semibold text-red mb-4"
        >
          <div v-if="!fetchingTempBucket">
            <span class="mr-2"><i class="fas fa-info-circle"></i></span>
            {{ $t('frontend_groovevideo_videos_no_temp_bucket') }}
          </div>
          <div v-else>
            {{ $t('frontend_groovevideo_videos_creating_temp_bucket') }}...
          </div>
        </div>
      </div>
    </div>
    <div v-else class="flex flex-col items-center justify-center p-4">
      <gd-button
        primary
        class="
          px-4
          h-10
          w-auto
          uppercase
          font-bold
          tracking-wide
          bg-green-extra-dark
          border-green-extra-dark
          hover:bg-green-dark hover:border-green-dark
        "
        @click="openUpgradeModal"
      >
        {{ $t('frontend_groovevideo_videos_upgrade_pro') }}
      </gd-button>
    </div>
    <!-- No storage added modal -->
    <add-storage-modal ref="addStorageModal" />
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import Video from '@/models/Video';
import AddStorageModal from '@/components/AddStorageModal';

export default {
  props: {
    useGrooveStorage: { default: false },
    storageId: {
      default() {
        return 0;
      },
    },
    storageFolder: {
      default() {
        return 0;
      },
    },
    encoderId: {
      default() {
        return 0;
      },
    },
    storage: {
      default() {
        return [];
      },
    },
    isPaid: {
      type: Boolean,
      default() {
        return {};
      },
    },
    headers: {},
    maxSize: {},
    model: {},
    videoDetails: {},
    validateForm: {},
    tabWidth: {},
  },
  components: {
    vueDropzone: vue2Dropzone,
    AddStorageModal,
  },
  data() {
    return {
      user: null,
      newActivity: {
        status: '',
        msg: '',
      },
      isEnabled: 1,
      btnVisible: '',
      video: this.model,
      awss3: {
        signingURL: this.getSigningUrl,
        headers: {
          email: this.$store.state.user.email,
          apiKey: this.$store.state.user.api_key,
        },
        params: {
          storageId: this.storageId,
          videoId:
            this.videoDetails && this.videoDetails.id
              ? this.videoDetails.id
              : null,
        },
        sendFileToServer: false,
        withCredentials: false,
      },
      dropzoneOptions: {
        acceptedFiles: '.mp4',
        url: `${window.config.apiUrl}/upload`,
        timeout: 99999999,
        maxFiles: 1,
        maxFilesize: this.maxSize,
        autoProcessQueue: false,
        autoQueue: true,
      },
      nextButtonDisabled: true,
      temporaryBucket: null,
      fetchingTempBucket: true,
    };
  },
  computed: {
    canUploadVideos() {
      return (
        this.useGrooveStorage ||
        (this.storageId > 0 && this.encoderId > 0 && this.storageFolder !== 0)
      );
    },
    videoUploadUrl() {
      return !this.useGrooveStorage || process.env.NODE_ENV === 'development'
        ? window.config.apiUrl
        : 'https://upload.gdapis.com/api/groovevideo';
    },
  },
  mounted() {
    this.user = this.$store.state.user.id;

    if (this.videoDetails) {
      this.video = this.videoDetails;
    }
  },
  async created() {
    if (this.useGrooveStorage) {
      this.temporaryBucket = true;
    } else {
      this.temporaryBucket = this.storage && this.storage.temporary_bucket;

      // Setting temporary bucket details
      if (this.storage.id && !this.temporaryBucket) {
        const storage = (
          await axios.post('create-temp-bucket', {
            storageId: this.storageId,
          })
        ).data.data;
        this.storage.temporary_bucket = storage;
        this.temporaryBucket = storage && storage.temporary_bucket;
      }
    }
    this.fetchingTempBucket = false;
  },
  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    sendBack() {
      this.$router.push({
        name: 'AddNewVideo',
        params: { id: this.$route.params.id },
      });
    },

    openUpgradeModal() {
      this.$refs.addStorageModal.open();
    },

    getSigningUrl() {
      if (this.useGrooveStorage) {
        return `${window.config.apiUrl}/get-groove-signing-url`;
      }
      return `${window.config.apiUrl}/get-signing-url`;
    },

    s3UploadError(errorMessage) {
      const self = this;
      self.hideLoader();
      self.newActivity = 'failed';
      self.createActivity();
      self.$refs.myVueDropzone.enable();
      self.isEnabled = 1;
    },

    uploadProgress(file, progress, bytesSent) {
      this.$emit('uploadProgress', file, progress, bytesSent, true);
    },
    totalProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      console.log(totaluploadprogress, totalBytes, totalBytesSent);
    },
    fileAdded(file) {
      const fileSize = (file.size / (1000 * 1000)).toFixed(1);

      // Validate
      const isValid = this.validateForm();

      // Max File Size Check
      if (fileSize > this.maxSize) {
        // Remove file in case greater than allowed file size
        this.$refs.myVueDropzone.removeFile(file);

        // Show error message
        Swal.fire(
          'Uplaod Error',
          `Files larger than ${this.maxSize}MB are not allowed.`,
          'error'
        );
      } else if (!isValid) {
        // Remove file in case invalid fields
        this.$refs.myVueDropzone.removeFile(file);
      } else {
        const self = this;
        // Timeout lets added file to get queued for processing
        setTimeout(async () => {
          // Check queued file
          if (self.$refs.myVueDropzone.getQueuedFiles().length) {
            const element = self.$el.querySelector('#customdropzone');
            if (element.classList.contains('dz-started')) {
              self.$emit('updateDisplayUploadbox', true);
            }
            // Creating video if it doesnot already exist
            if (!this.video.id) {
              await this.createVideo();
            }
            // Initiate file upload
            self.$refs.myVueDropzone.processQueue();
          }
        }, 300);
      }
    },
    includeHttps(url) {
      return url.replace(/^(?:(.*:)?\/\/)?(.*)/i, (match, schemma, nonSchemmaUrl) => schemma ? match : `https://${nonSchemmaUrl}`);
    },
    async uploadSuccess(file, response) {
      if (response && response.Location) {
        let s3URL = decodeURIComponent(response.Location);
        // Append schema if not present
        s3URL = this.includeHttps(s3URL);
        await this.s3UploadSuccess(s3URL);
      }
    },
    async s3UploadSuccess(s3ObjectLocation) {
      const self = this;
      const files = self.$refs.myVueDropzone.getAcceptedFiles();
      if (files.length) {
        const fileSize = files[0].size;

        const allowedUsers = [
          '5f0d5d4a6ca1bd0016c5142f',
          '9d280130-6f1d-429a-8231-b7d77de8c3c4',
        ];

        const currentUserAllowed = allowedUsers.includes(this.user);

        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = URL.createObjectURL(files[0]);
        let [duration, videoHeight, videoWidth] = [0, 0, 0];

        video.addEventListener('loadedmetadata', async (e) => {
          video = e.path[0];
          window.URL.revokeObjectURL(video.src);
          duration = video.duration;
          videoHeight = video.videoHeight;
          videoWidth = video.videoWidth;
        });

        setTimeout(async () => {
          const s3UploadSuccessData = await axios.post(
            `${this.videoUploadUrl}/s3upload`,
            {
              vid: self.video.id,
              vName: self.video.name,
              vCategory: self.video.category_id,
              storageId: self.storageId,
              encoderId: self.encoderId,
              folder: self.storageFolder,
              isPaid: self.useGrooveStorage && self.isPaid,
              fileLink: s3ObjectLocation,
              duration,
              videoHeight,
              videoWidth,
              fileSize,
            },
            {
              headers: {
                email: this.$store.state.user.email,
                apiKey: this.$store.state.user.api_key,
              },
            }
          );

          const uploadResponse = s3UploadSuccessData.data;

          if (uploadResponse.status == 'uploading') {
            self.newActivity = 'uploading';
            this.btnVisible = 'progress100';
            this.nextButtonDisabled = false;
            self.createActivity();
            this.addVideo();
          } else if (
            uploadResponse.status == 'encoding' ||
            uploadResponse.status == 'processing'
          ) {
            self.$refs.myVueDropzone.disable();
            self.isEnabled = 0;
            self.hideLoader();
            self.newActivity = 'encoding';
            this.btnVisible = 'progress100';
            this.nextButtonDisabled = false;
            self.createActivity();
            this.addVideo();
          } else if (uploadResponse.status == 'uploaded') {
            self.$refs.myVueDropzone.disable();
            self.isEnabled = 0;
            self.hideLoader();
            self.newActivity = 'uploaded';
            this.btnVisible = 'progress100';
            this.nextButtonDisabled = false;
            self.createActivity();
            this.addVideo();
          } else {
            this.uploadError();
          }
        }, 500);
      }
    },
    async uploadError(uploadFailed = false) {
      const self = this;
      if (!uploadFailed && !self.$route.params.id) {
        const vid = await Video.$find(self.video.id);
        self.video = {
          name: vid.name,
          category_id: vid.category_id,
        };
        await vid.delete();
      }
      self.hideLoader();
      self.newActivity = 'failed';
      self.btnVisible = 'progress100';
      await Swal.fire({
        type: 'error',
        title: 'Error',
        text: 'Cannot upload video. Please try again',
        reverseButtons: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
      });
      self.$emit('updateDisplayUploadbox', false);
      self.createActivity();
      self.$refs.myVueDropzone.removeAllFiles();
      self.$refs.myVueDropzone.enable();
      self.isEnabled = 1;
    },
    async createVideo() {
      // Create Video
      const video = new Video({
        name: this.video.name,
        category: this.video.category_id,
        storageId: this.storageId,
      });
      this.video = (await video.save()).data;
    },
    createActivity() {
      this.$emit('activityCreated', this.newActivity);
    },
    addVideo() {
      // Redirect only when button is active
      if (!this.nextButtonDisabled) {
        this.$router.push({
          name: 'AddNewVideo',
          params: {
            id: this.video.id,
            activityCreated: this.newActivity,
          },
        });
      }
    },
  },
};
</script>